type GuardrailUserRole = "patient navigator" | "referrer" | "patient";

interface InsuranceExclusionPolicy {
  name?: string;
  exclusion_ind?: boolean;
  roles_allowed_to_override?: string[] | null;
}

/**
 * Patient Navigators are allowed to bypass age/screener guardrails that
 * would otherwise route patients to Contact Us.
 */
export const canRoleBypassGuardrails = (userRole?: GuardrailUserRole): boolean => {
  return normalizeRole(userRole) === "patient navigator";
};

function normalizeRole(role?: GuardrailUserRole | string): string {
  return (role ?? "")
    .trim()
    .toLowerCase()
    .replace(/[-_\s]+/g, " ");
}

export const canRoleOverrideInsuranceExclusion = (
  userRole?: GuardrailUserRole,
  rolesAllowedToOverride?: string[] | null,
): boolean => {
  if (!userRole || !Array.isArray(rolesAllowedToOverride) || rolesAllowedToOverride.length === 0) {
    return false;
  }

  return rolesAllowedToOverride.some((role) => {
    return normalizeRole(role) === normalizeRole(userRole);
  });
};

export const isEapInsurancePolicy = (policy?: InsuranceExclusionPolicy | null): boolean => {
  return typeof policy?.name === "string" && /\bEAP\b/i.test(policy.name);
};

export const shouldRouteInsurancePolicyToContact = (
  policy?: InsuranceExclusionPolicy | null,
  userRole?: GuardrailUserRole,
): boolean => {
  if (!policy || (!policy.exclusion_ind && !isEapInsurancePolicy(policy))) {
    return false;
  }

  return !canRoleOverrideInsuranceExclusion(userRole, policy.roles_allowed_to_override);
};
